module.exports = __webpack_public_path__ + "static/img/アセット 23@2x.b9111f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 23@2x.png
// module id = ds4Y
// module chunks = 1